<template lang="pug">
  TransitionExpand
    .grid(v-for="(item, index) in state" :key="item.id")
      .regra
        NovoApontamento(
          :indice="index"
          :regraApontamento="item"
          :comparacoes="comparacoes.loaded"
        )
      .botao.deletar(v-if="index > 0")
        PButton(size="sm" color="danger" @click="deletarRegra(index)")
          .icon-ptt-icons-excluir
      .botao.adicionar(v-if="index === (state.length - 1)")
        PButton(
          @click="adicionarNovaRegra"
          :disabled="!ehValido(index)"
          color="warning"
          size="sm"
        ) adic. evento
</template>

<script>
import { mapState } from 'vuex'
import { uniqueId } from 'lodash'

import { handlerUseStateVmodel } from 'src/common/mixins/handlerUseStateVmodel'
import NovoApontamento from './NovoApontamento'

export default {
  name: 'CustomApontamentos',
  props: {},
  created () {
    if (this.state.length === 0) {
      this.adicionarNovaRegra()
    }
  },
  data () {
    return {
      comparacoes: {
        loaded: [
          { id: 'min', name: 'maior ou igual a' },
          { id: 'max', name: 'menor ou igual a' },
          { id: 'between', name: 'entre' }
        ],
        selected: {id: 'min', name: 'maior ou igual a'}
      },
      contagem: 0
    }
  },
  computed: {
    ...mapState('approvalsRules/details', ['apontamentos'])
  },
  methods: {
    ehValido (index) {
      const { min, apontamento } = this.state[index]
      return min.float !== 0.0 && apontamento
    },
    adicionarNovaRegra () {
      this.state.push({
        id: uniqueId(),
        apontamento: this.apontamentos[0],
        comparacao: this.comparacoes.selected,
        min: { hours: 0, minutes: 0, float: 0.0 },
        max: { hours: 0, minutes: 0, float: 0.0 }
      })
    },
    deletarRegra (index) {
      this.$delete(this.state, index)
    }
  },
  mixins: [handlerUseStateVmodel(true)],
  components: { NovoApontamento }
}
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 530px 33px auto;
  column-gap: 5px;

  .botao {
    align-self: center;
  }

  .botao.adicionar {
    grid-column: 3/4;
  }
}
</style>
